










import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { EPLModule } from '../store/eplmodule'

@Component({ name: 'ActionFields' })
export default class ActionFields extends Vue {
  @Prop() json!: string
  @Prop() label!: string

  list = ''

  get value () {
    return this.list
  }

  @Watch('json')
  onJsonChange () {
    this.setList()
  }

  mounted () {
    this.setList()
  }

  private setList () {
    this.list = ''
    const t = this.json.split('~~~')
    if (t[1] !== undefined) {
      EPLModule.fetchHeadersList(t[1])
        .then(() => {
          if (t[0][0] === '{') {
            const list = JSON.parse(t[0])
            for (const e in list) {
              this.list += `${this.getName(e)}: "${list[e]}"\n`
            }
          } else {
            this.list = t[0]
          }
        })
    }
  }

  private getName (field: string): string {
    const names = EPLModule.lists['HEADERS-HEADERS' as any]
    let res = ''
    names.forEach(n => {
      if (n.value === field) {
        res = n.text
      }
    })
    return res
  }
}
